import React from 'react';
import Modal from 'react-modal';
import IconButton from '../icon-button/icon-button';
import { IconCircleClose2 } from '../icons';
import Styles from './modal-certificates-styles.scss';
Modal.setAppElement('#main');
const DefaultModalCertificates = ({ open, onClose, children, title = null, subTitle = null, width = 83, wUnit = 'vh', height = 'auto', hUnit = '', showClose = false, contentCustomStyles = {}, overlayCustomStyles = {}, backgroundColor = '#FBF6F0', padding = '56px' }) => {
    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        // subtitle.style.color = '#f00';
    }
    function closeModal() {
        if (onClose)
            onClose();
    }
    const customStyles = {
        content: Object.assign({ top: '50%', left: '50%', right: 'auto', bottom: 'auto', dispplay: 'flex', marginRight: '-50%', background: backgroundColor, width: `${width}${wUnit}`, height: `${height}${hUnit}`, transform: 'translate(-50%, -50%)', borderRadius: 0, boxShadow: '15px 20px 50px 15px rgba(65, 65, 65, 0.08)' }, contentCustomStyles),
        overlay: Object.assign({ background: '#00000066', zIndex: '2000' }, overlayCustomStyles)
    };
    return (React.createElement(Modal, { isOpen: open, onAfterOpen: afterOpenModal, onRequestClose: closeModal, style: customStyles, className: Styles.defaultModal, zIn: true },
        showClose && (React.createElement(IconButton, { className: Styles.headerModal, onClick: closeModal },
            React.createElement(IconCircleClose2, { color: "white" }))),
        title !== null && React.createElement("h1", { className: Styles.title }, title),
        subTitle !== null ? (React.createElement("div", null,
            React.createElement("p", { className: Styles.subtitle }, subTitle))) : (''),
        children));
};
export default DefaultModalCertificates;
